import {
  Popover,
  type PopoverProps,
} from '@mantine/core'
import { useTimeout } from '@mantine/hooks'
import { useState } from 'react'

import { type PopoverPosition, PopoverTrackedContext, type PopoverTrackedContextState } from './PopoverTrackedContext'
import { PopoverTrackedDropdown } from './PopoverTrackedDropdown'
import { PopoverTrackedTarget } from './PopoverTrackedTarget'
import { usePopoverTrackedState } from './usePopoverTrackedState'

export * from './usePopoverTrackedState'

export type PopoverTrackedParams = Omit<PopoverProps, 'width' | 'height'> & {
  id: string | number
  height?: number
  width?: number
}

export function PopoverTracked({
  id,
  children,
  height = 290,
  width = 500,
}: PopoverTrackedParams) {
  const { popoverIdOpened, setPopoverIdOpened } = usePopoverTrackedState()

  const isOpened = id === popoverIdOpened

  const popoverId = id

  const [position, setPosition] = useState<PopoverPosition>({
    bottom: undefined,
    left: undefined,
    right: undefined,
    top: undefined,
  })

  const handleMove = useTimeout(async (position: PopoverPosition[]) => {
    setPopoverIdOpened(id)
    setPosition(position[0])
  }, 500)

  const handleClose = useTimeout(() => {
    setPopoverIdOpened(null)
  }, 200)

  const state: PopoverTrackedContextState = {
    popoverId,
    height,
    width,
    position,
    handleMove,
    handleClose,
  }

  return (
    <PopoverTrackedContext.Provider value={state}>
      <Popover opened={isOpened} shadow='md'>
        {children}
      </Popover>
    </PopoverTrackedContext.Provider>
  )
}

PopoverTracked.Target = PopoverTrackedTarget
PopoverTracked.Dropdown = PopoverTrackedDropdown
